export const testimonialList = [
  {
    ime: "Vesna Šoša",
    testimonial:
      "Hvala vam na vašem trudu, ljubaznosti i ugodnom boravku u vašoj ordinaciji. Ja sam prezadovoljna vašom uslugom i krajnjim rezultatom.",
  },
  {
    ime: "T.R.",
    testimonial:
      "Godina već dolazim kod dr Kolega i cijeli tim je tako ugodan i stručan da su svi moji strahovi odavno prošli, redovit sam na kontroli i više nemam nikakvih problema već jako dugo.",
  },
  {
    ime: "Duška Pavić",
    testimonial:
      "Imam kćer s autizmom i svi su mi govorili da ne sanjam o popravcima zubiju bez opće anestezije. Ja sam se usudila sanjati i skupa sa vrhunskim timom u ordinaciji, zub je popravljen bez problema. Riječi koje opisuju dr. Kolega su: strpljivost, smirenost, stručnost, a prije svega ljudskost.",
  },
  {
    ime: "Božena Poljančić",
    testimonial:
      "Nakon skoro 20 godina zajedničkog druženja, nisam mogla pronaći bolje, sposobnije i uslužnije osoblje. U novom prostoru je predivno, prijateljsko okruženje, cijela obitelj je upisana, a najmlađi član je oduševljen pristupom i nema nikakav strah od stomatologa. Zato imam samo sve riječi pohvale i želim uspjeh u daljnjem radu.",
  },
  {
    ime: "Tomislav Srzentić",
    testimonial:
      "Top usluga i osoblje, puno puta izašli u susret u zadnji tren, nakon 35godina više se ne bojim stomatologa. Na novoj lokaciji još ljepši ambijent.",
  },
  {
    ime: "Nataša Butić",
    testimonial:
      "Brzo,efikasno i uslužno. Izuzetno ljubazno osoblje,ugodna atmosfera,divan interijer. Dolaskom u ordinaciju strah od posjete stomatologu u potpunosti nestaje.",
  },
  {
    ime: "Lara Kajmak",
    testimonial:
      "Volimo se smijati. Onako glasno, od srca, da se vide umnjaci. 20-tak godina poznanstva i povjerenja koje je preraslo u prijateljstvo,  izuzetno ugodan novi prostor, odlična lokacija te iznimno uslužna, strpljiva i stručna ekipa koju čine: Zrinka, Jasna i Nevena. Moja potraga za stvarnom „Zubić Vilom“ odavno završena. Nemam se namjere prestati hvaliti sa vama i preporučiti vas bez straha. ",
  },
]
